import i18n from "@/libs/i18n";
export default [
  {
    get header() {
      return i18n.t("lab.lab");
    },
    permission: "get-test",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("common.patients");
    },
    route: "patients-lab",
    icon: "HomeIcon",
    permission: "get-patient",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("lab.main-lab");
    },
    route: "patients-tests",
    icon: "SlidersIcon",
    permission: "get-patient",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("lab.test");
    },
    route: "test",
    icon: "ZoomInIcon",
    permission: "get-test",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("lab.group");
    },
    route: "group",
    icon: "UsersIcon",
    permission: "get-group",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("lab.test-group");
    },
    route: "test-group",
    icon: "CommandIcon",
    permission: "get-testGroup",
    role: "Lab",
  },

  {
    get title() {
      return i18n.t("lab.unit");
    },
    route: "unit-lab",
    permission: "get-unit",
    icon: "SlidersIcon",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("lab.lis-data");
    },
    route: "lis-data",
    permission: "get-unit",
    icon: "DatabaseIcon",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("lab.test-devices");
    },
    route: "test-devices",
    permission: "get-unit",
    icon: "ArchiveIcon",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("lab.TestNormalRanges");
    },
    route: "test-normal-ranges",
    permission: "get-unit",
    icon: "ArchiveIcon",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("lab.special-test-report");
    },
    route: "special-test-report",
    permission: "get-test",
    icon: "ArchiveIcon",
    role: "Lab",
  },
  {
    get title() {
      return i18n.t("lab.test-report-result");
    },
    route: "test-report-result",
    icon: "ArchiveIcon",
    role: "Lab",
  },
];
